import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    condensedViewCard: {
      padding: '16px',
      borderRadius: '8px 8px 8px 8px',
      margin: 16,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      cursor: 'pointer',
      '& .tooltipTextColor': {
        color: 'rgba(255, 255, 255, 0.87) ',
      },
      '& .inlineGrid': {
        display: 'inline ',
      },
    },
    condensedViewGrid: {
      padding: 0,
    },
    condensedViewInnerGrid: {
      paddingLeft: 8,
    },
    greenDot: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
      margin: '0px 8px 4px 8px',
    },
    areaPcsId: {
      fontWeight: 'normal',
      color: 'rgba(255, 255, 255, .38)',
    },
    inlineBlock: {
      display: 'inline-block',
    },
    messageIcon: {
      verticalAlign: 'text-bottom',
      marginLeft: 16,
    },
    condensedViewRisk: {
      fontSize: 12,
      fontWeight: 400,
      color: 'rgba(255, 255, 255, 0.38)',
    },
    condensedViewDescription: {
      fontSize: 14,
      fontWeight: 400,
      color: 'rgba(255, 255, 255, 0.38)',
      lineHeight: '24px',
      maxHeight: '24px',
      overflow: 'hidden',
    },
    deficiencyDetailsCard: {
      display: 'inline',
    },
    condensedViewData: {
      fontSize: 20,
      fontWeight: 300,
      color: 'rgba(255, 255, 255, 0.38)',
    },
    condensedViewPhotoGrid: {
      paddingRight: 8,
    },
    condensedViewImage: {
      backgroundSize: 'cover',
      height: 50,
      width: 50,
      borderRadius: 4,
      border: '1px dashed rgba(255, 255, 255, 0.12)',
    },
    condensedViewImageText: {
      textAlign: 'center',
      color: 'rgba(255, 255, 255, 0.87)',
      alignSelf: 'center',
    },
    bgImage: {
      backgroundImage: (props?: { imageURL?: string }) => `url("${props?.imageURL}")`,
    },
    cardViewPhotoBackground: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
    photoDivCondensedView: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50px',
    },
    loader: {
      padding: '8px',
      margin: '4px 0px 0px 2px',
    },
    condensedViewCopyIcon: {
      padding: '8px',
      marginLeft: 16,
    },
    deleteIcon: {
      marginLeft: 16,
    },
    customHistory: {
      width: '28px !important',
      height: '28px !important',
      marginRight: '6px',
      cursor: 'pointer',
    },
    alertCircle: {
      width: '24px',
      height: '24px',
      marginLeft: '10px',
      marginBottom: '-5px',
      cursor: 'pointer',
    },
    messageAttention: {
      marginLeft: '12px',
      marginBottom: '-10px',
      width: '30px',
      height: '30px',
    },
    dividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
      background: 'rgba(255,255,255,0.4)',
    },
    reInspected: {
      backgroundColor: '#2AAB3F',
      margin: '-7px 0 0 -7px',
      borderRadius: '10px 0 0 0',
    },
    removedFromPlanning: {
      backgroundColor: '#dd7676',
      margin: '-7px 0 0 -7px',
      borderRadius: '10px 0 0 0',
    },
  }),
);

export default useStyles;
